









import Campaign from "@/models/campaign";
import { Component, Vue } from "vue-property-decorator";
import CampaignForm from "./Components/CampaignForm.vue";
import CampaignAPI from "@/services/campaigns";
import { LayoutModule } from "@/store/layout";
import { UserModule } from "@/store/user";
import { CampaignModule } from "@/store/campaign";
import { LineItemModule } from "@/store/lineItem";
import { cloneDeep } from "lodash";

@Component({
  components: {
    CampaignForm,
  },
})
export default class NewCampaign extends Vue {
  created(): void {
    CampaignModule.setCurrentCampaign(new Campaign());
  }

  async save(campaign: Campaign): Promise<void> {
    try {
      const c = cloneDeep(campaign);

      c.userId = UserModule.getCurrentUser.id;
      c.lineItems = LineItemModule.getLineItems;
      const r = await CampaignAPI.new(c);

      LayoutModule.setAlerts({
        text: this.$t("campaigns.responses.success_create").toString(),
        type: "success",
      });

      r && r.id
        ? this.$router.push({
            name: "edit-campaign",
            params: { id: String(r.id) },
          })
        : null;
    } catch (e) {
      console.log(e);
    }
  }
}
